import styled from 'styled-components'
import { breakpoints, Grid } from '@gassan-ui'
import { MinWidthProps, minWidth } from 'styled-system'
import { rem } from 'polished'

export const Slider = styled.div`
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  display: flex;
  overflow-x: scroll;
  margin-bottom: 20px;

  /** Disallow swiping on non-touch devices */
  @media (hover: hover) and (pointer: fine) {
    overflow-x: hidden;
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
`

export const NavButton = styled.button<{ direction: 'left' | 'right' }>`
  transition: opacity 0.2s ease-in-out;
  outline: 0;
  position: absolute;
  width: 3rem;
  height: 3rem;
  top: 50%;
  z-index: 2;
  /* margin-top: -1rem; */
  left: ${p => p.direction === 'left' && '-3rem'};
  right: ${p => p.direction === 'right' && '-3rem'};
  display: none;
  justify-content: center;
  align-content: center;
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  @media screen and (min-width: ${breakpoints.small}) {
    display: flex;
  }
`

export const Slide = styled(Grid)<MinWidthProps & { isActive?: boolean }>`
  ${minWidth};
  border: 1px solid #fff;
  scroll-snap-align: start;
  transition: opacity 0.2s ease-in-out;
`

export const NavButtons = styled.div`
  position: absolute;
  width: calc(100% + ${rem(50)});
  top: 50%;
  left: ${rem(-25)};
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  justify-content: space-between;
  z-index: 2;
`
